import imageOne from '@/assets/images/cities/northYork1.jpg'
import imageTwo from '@/assets/images/cities/northYork2.jpg'
import imageThree from '@/assets/images/cities/northYork3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'North York',
  writeup: '',
  website: 'MyNorthYorkNotary.com',
  url: 'https://www.mynorthyorknotary.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(647) 738-5550',
      hours: {
        monday: '9:30AM to 5:00PM',
        tuesday: '9:30AM to 5:00PM',
        wednesday: '9:30AM to 5:00PM',
        thursday: '9:30AM to 5:00PM',
        friday: '9:30AM to 5:00PM',
        saturday: '',
        sunday: ''
      },
      address: '333 Sheppard Avenue East Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/northYork.js